<mat-form-field [style.width.%]="100" appearance="fill">
  <mat-label translate>FormulaParameters.data_source</mat-label>
  <mat-select [(ngModel)]="selectedDataSource" (selectionChange)="dataSourceChange()">
    <mat-option *ngFor="let source of listDataSources" [value]="source">
      {{ source }}
    </mat-option>
  </mat-select>
</mat-form-field>
